import { render, staticRenderFns } from "./ComplainOrder.vue?vue&type=template&id=06ce4cf8&scoped=true"
import script from "./ComplainOrder.vue?vue&type=script&lang=ts"
export * from "./ComplainOrder.vue?vue&type=script&lang=ts"
import style0 from "./ComplainOrder.vue?vue&type=style&index=0&id=06ce4cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce4cf8",
  null
  
)

export default component.exports